import { createSelector } from '@reduxjs/toolkit';

import { rootStateBranchSelector } from '../rootStateBranchSelector';

const adfoxSelector = rootStateBranchSelector('adfox');

export const selectPuids = createSelector(adfoxSelector, state => state.puids);
